import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ConnectionsTab from "../../components/profile/ConnectionTab";

const ConnectionsPage = () => {
  const { t } = useTranslation();
  const currentUser = useSelector((s) => s.auth?.user);

  if (!currentUser?.id) {
    return (
      <div className="p-6 text-gray-400">
        {t('connections.unableToLoad')}
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      <ConnectionsTab
        userId={currentUser.id}
        isOwner={true}
      />
    </div>
  );
};

export default ConnectionsPage;
